
<template>
  <!-- fixed-top-->
  <div>
  <nav class="navbar navbar-expand-lg navbar-dark bg-ligth" aria-label="Ninth navbar example">
    <div class="container-xl">
      <a class="navbar-brand " @click="$router.push('/user-inicio-usuario').catch(err => {})"><img src="@/assets/img/logo.png" alt="logo" class="logo-kallpa"></a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample07XL" aria-controls="navbarsExample07XL" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarsExample07XL">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link text-center inicio" @click="$router.push('/user-inicio-usuario').catch(err => {})">
               <i class="flaticon-home"></i><br>
                Inicio</a>
          </li>
          <li class="nav-item">
                <a class="nav-link text-center" @click="$router.push('/user-operaciones-verificando').catch(err => {})">
                   <i class="flaticon-dollar"></i><br>
                    Operaciones</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-center" @click="$router.push('/user-cuentas-usuario').catch(err => {})" aria-current="page" >
                <i class="flaticon-bank-sign"></i> <br>
                Cuentas</a>
          </li>
        
          <li class="nav-item dropdown"><a class="nav-link pe-0" id="navbarDropdownUser" @click="$router.push('/user-perfil').catch(err => {})" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <div class="avatar avatar-xl text-center">
                <i class="flaticon-user"></i> 
                <br>
               <small> Perfil</small>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-end py-0" aria-labelledby="navbarDropdownUser" data-bs-popper="none">
            <div class="bg-white dark__bg-1000 rounded-2 py-2">
              <a class="dropdown-item" href="#!">Set status</a>
              <a class="dropdown-item" href="pages/user/profile.html">Profile &amp; account</a>
              <a class="dropdown-item" href="#!">Feedback</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="pages/user/settings.html">Settings</a>
              <a class="dropdown-item" href="pages/authentication/card/logout.html">Logout</a>
            </div>
          </div>
        </li>
        </ul>
      </div>
    </div>
  </nav>
  <router-link to="/preguntas" target="_blank" class="chat">
    <img style="margin: 11px;" src="@/assets/img/chat.png" width="">
  </router-link>
</div>
  <!-- ////////////////////////////////////////////////////////////////////////////-->
</template>

<script>


export default {
  name: "HeaderAuth",
  data() {
    return {
      
    };
  },
   mounted() {
    
    
  },
  created() {
     
  },
  methods:{
    
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/user/Header.vue